const state = {
  ppob_products: [],
  ppob_product: {},
};

export default state;
